import Vue from 'vue';
import { ethers } from 'ethers';
import store from '@/store';
import provider from '@/helpers/provider';

import nftABI from '@/helpers/abi/ExtremeNFT.json';

const ethereum = window['ethereum'];
if (ethereum) {
  ethereum.on('accountsChanged', () => {
    store.dispatch('init');
    store.commit('set', { address: null });
  });
  ethereum.on('networkChanged', network => {
    store.commit('set', { network: ethers.utils.getNetwork(parseInt(network)) });
  });
}
function grabJson(nftid) {
  return fetch('https://extremenft.io/json/'+nftid).then(response => {
    console.log(response);
    return response.json()
  })
}  
const state = {
  loading: false,
  address: null,
  nftContract: null,
  nftAddress: '0xc7Fb5Ea543819dd0574B6644A6B7750C452aDc89',
  price: ethers.utils.parseEther('0'),
  name: '',
  balance: 0,
  claim: 0,
  minimumEth: 0,
  providedEth: 0,
  remainingEth: 0,
  network: {},
  exchangeRates: {},
  allowances: {},
  balances: {},
  collections: {},
  minted: {},
  remaining: {},
  portfolio: null,
  authorized: false,
  allowanceTx: 0,
  saleTx: 0,
  confirmations: 1
};

const mutations = {
  set(_state, payload) {
    Object.keys(payload).forEach(key => {
      Vue.set(_state, key, payload[key]);
    });
  },
  addToPortfolio(state, image) {
    if(state.portfolio === null) state.portfolio = []
    state.portfolio.push(image);
  }
};

const actions = {
  init: async ({ commit, dispatch }) => {
    commit('set', { loading: true });
    console.log(provider);
    if (provider) {
      try {
        const signer = provider.getSigner();
        const address = await signer.getAddress();
        if (address) await dispatch('login');
      } catch (e) {
        console.log(e);
      }
    }
    commit('set', { loading: false });
  },
  login: async ({ commit, dispatch }) => {
    if (provider) {
      try {
        await ethereum.enable();
        const signer = provider.getSigner();
        const address = await signer.getAddress();
        const balance = await signer.getBalance();

        const network = await provider.getNetwork();
        const nftContract = new ethers.Contract(state.nftAddress, nftABI, signer);
        const minted = await nftContract.getMinted();
        const collections = await nftContract.getCollections();
        const price = await nftContract.basePrice();
        const remaining = minted.map((num, i) => {
          return collections[i] - num;
        });
        console.log(remaining);
        commit('set', { address });
        commit('set', {
          network,
          balance,
          minted,
          remaining,
          price,
          loading: false
        });
        dispatch('subscribeToTransferEvent');
      } catch (error) {
        console.error(error);
      }
    } else {
      console.error('This website require MetaMask');
    }
  },

  loading: ({ commit }, payload) => {
    commit('set', { loading: payload });
  },

  async subscribeToTransferEvent({ commit }) {
    const signer = await provider.getSigner();
    const nftContract = new ethers.Contract(state.nftAddress, nftABI, signer);
    const minterAddress = state.address;

    nftContract.on('Transfer', async (from, to, nftid) => {
      const minted = await nftContract.getMinted();
      const collections = await nftContract.getCollections();
      const remaining = minted.map((num, i) => {
        return collections[i] - num;
      });
      
      if (from == ethers.constants.AddressZero) {
        if (to == minterAddress) {
           const json = await grabJson(nftid)
           json.id = nftid;
           commit('addToPortfolio', { image: json });
        }
      }
      commit('set', {
        remaining
      });
    });
  },

  async mint({ commit }, { quantity_, collection }) {
    const signer = provider.getSigner();
    const basePrice = state.price;
    const price = basePrice.mul(quantity_);
    const nftContract = new ethers.Contract(state.nftAddress, nftABI, signer);
    commit('set', { loading: true });

    try {
      let mintFunction;
      switch (collection) {
        case 'A':
          mintFunction = nftContract.mintA;
          break;
        case 'B':
          mintFunction = nftContract.mintB;
          break;
        case 'C':
          mintFunction = nftContract.mintC;
          break;
        case 'D':
          mintFunction = nftContract.mintD;
          break;
        case 'E':
          mintFunction = nftContract.mintE;
          break;
        case 'F':
          mintFunction = nftContract.mintF;
          break;
        case 'G':
          mintFunction = nftContract.mintG;
          break;
        case 'H':
          mintFunction = nftContract.mintH;
          break;
        case 'I':
          mintFunction = nftContract.mintI;
          break;
        case 'J':
          mintFunction = nftContract.mintJ;
          break;
      }
      const resp = mintFunction({ value: price })
        .then(txn => {
          provider.waitForTransaction(txn.hash).then(receipt => {
            console.log(receipt);
          });
        })
        .catch(e => {
          console.log(e);
        });
      await resp.wait();
    } catch (e) {
      console.log(e);
    }
    commit('set', { loading: false });
  },

};

export default {
  state,
  mutations,
  actions
};
